import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2707_26561)">
      <path
        d="M5.58394 8C7.58312 8 9.20894 6.37419 9.20894 4.375C9.20894 2.37581 7.58312 0.75 5.58394 0.75C3.58475 0.75 1.95894 2.37581 1.95894 4.375C1.95894 6.37419 3.58475 8 5.58394 8ZM5.58394 1.95833C6.91673 1.95833 8.0006 3.04221 8.0006 4.375C8.0006 5.70779 6.91673 6.79167 5.58394 6.79167C4.25115 6.79167 3.16727 5.70779 3.16727 4.375C3.16727 3.04221 4.25115 1.95833 5.58394 1.95833ZM6.18327 9.77504C6.22435 10.1061 5.98994 10.4076 5.65825 10.4493C3.5491 10.7127 1.95833 12.5161 1.95833 14.6458C1.95833 14.9793 1.68767 15.25 1.35417 15.25C1.02067 15.25 0.75 14.9793 0.75 14.6458C0.75 11.9084 2.79571 9.58896 5.50842 9.25062C5.83587 9.20894 6.14098 9.44396 6.18267 9.77565L6.18327 9.77504ZM14.4628 12.3095L13.8743 11.97C13.9746 11.6697 14.0423 11.3543 14.0423 11.0202C14.0423 10.6861 13.9752 10.3708 13.8743 10.0705L14.4628 9.73094C14.7516 9.56419 14.8506 9.19444 14.6839 8.90565C14.5165 8.61625 14.1474 8.51717 13.8586 8.68452L13.2707 9.02406C12.8448 8.54435 12.2775 8.19333 11.6256 8.06102V7.39583C11.6256 7.06233 11.3549 6.79167 11.0214 6.79167C10.6879 6.79167 10.4173 7.06233 10.4173 7.39583V8.06102C9.76537 8.19394 9.19806 8.54496 8.77213 9.02406L8.18427 8.68452C7.89367 8.51717 7.52573 8.61625 7.35898 8.90565C7.19223 9.19504 7.29131 9.56419 7.5801 9.73094L8.16856 10.0705C8.06827 10.3708 8.0006 10.6861 8.0006 11.0202C8.0006 11.3543 8.06767 11.6697 8.16856 11.97L7.5801 12.3095C7.29131 12.4763 7.19223 12.846 7.35898 13.1348C7.47135 13.3288 7.67375 13.4369 7.88279 13.4369C7.9849 13.4369 8.08881 13.4109 8.18427 13.3559L8.77213 13.0164C9.19806 13.4961 9.76537 13.8471 10.4173 13.9794V14.6446C10.4173 14.9781 10.6879 15.2488 11.0214 15.2488C11.3549 15.2488 11.6256 14.9781 11.6256 14.6446V13.9794C12.2775 13.8465 12.8448 13.4955 13.2707 13.0164L13.8586 13.3559C13.9541 13.4109 14.058 13.4369 14.1601 13.4369C14.3691 13.4369 14.5721 13.3288 14.6839 13.1348C14.8506 12.8454 14.7516 12.4763 14.4628 12.3095ZM11.0214 12.8327C10.0221 12.8327 9.20894 12.0195 9.20894 11.0202C9.20894 10.0209 10.0221 9.20773 11.0214 9.20773C12.0207 9.20773 12.8339 10.0209 12.8339 11.0202C12.8339 12.0195 12.0207 12.8327 11.0214 12.8327Z"
        fill="#151718"
      />
    </g>
    <defs>
      <clipPath id="clip0_2707_26561">
        <rect
          width="14.5"
          height="14.5"
          fill="white"
          transform="translate(0.75 0.75)"
        />
      </clipPath>
    </defs>
  </svg>
);

const TeamIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default TeamIcon;
